// extracted by mini-css-extract-plugin
var _1 = "PostStyle-module__post-container___eEgdW";
var _2 = "PostStyle-module__post-owner__label___BlRE9";
var _3 = "PostStyle-module__post__comment-on___Zrg73";
var _4 = "PostStyle-module__post-container___eEgdW";
var _5 = "PostStyle-module__post__content___asGGt";
var _6 = "PostStyle-module__post__content__deleted___VVBI5";
var _7 = "PostStyle-module__post__content__holder___rtGhf";
var _8 = "PostStyle-module__post__info___iz6AQ";
var _9 = "PostStyle-module__post__info__details___oPVfk";
var _a = "PostStyle-module__post__info__details__date___nwDJX";
var _b = "PostStyle-module__post__info__details__name___O98SW";
var _c = "PostStyle-module__post__info__img___P2uBD";
var _d = "PostStyle-module__post__other___yvdq1";
var _e = "PostStyle-module__post-owner__label___BlRE9";
var _f = "PostStyle-module__post__comment-on___Zrg73";
var _10 = "PostStyle-module__post__content___asGGt";
var _11 = "PostStyle-module__post__content__deleted___VVBI5";
var _12 = "PostStyle-module__post__content__holder___rtGhf";
var _13 = "PostStyle-module__post__info___iz6AQ";
var _14 = "PostStyle-module__post__info__details___oPVfk";
var _15 = "PostStyle-module__post__info__details__date___nwDJX";
var _16 = "PostStyle-module__post__info__details__name___O98SW";
var _17 = "PostStyle-module__post__info__img___P2uBD";
var _18 = "PostStyle-module__post__other___yvdq1";
export { _1 as "post-container", _2 as "post-owner__label", _3 as "postCommentOn", _4 as "postContainer", _5 as "postContent", _6 as "postContentDeleted", _7 as "postContentHolder", _8 as "postInfo", _9 as "postInfoDetails", _a as "postInfoDetailsDate", _b as "postInfoDetailsName", _c as "postInfoImg", _d as "postOther", _e as "postOwnerLabel", _f as "post__comment-on", _10 as "post__content", _11 as "post__content__deleted", _12 as "post__content__holder", _13 as "post__info", _14 as "post__info__details", _15 as "post__info__details__date", _16 as "post__info__details__name", _17 as "post__info__img", _18 as "post__other" }
